import { useEffect } from 'react';

import { checkFeatureFlagGate } from '@wac-web/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@wac-web/utils/feature-flags/feature-flag-manifest';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useFastshiftSelector } from '@/state';

export const useMigrationTicketsListSectionAnalytics = () => {
	const isOrganizationRedesignEnabled = checkFeatureFlagGate(
		featureFlags.sxpFspOrganizationRedesign,
	);
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

	const selectedDomainOrg = useFastshiftSelector((state) => state.selectedDomainOrg);

	const { data: topSupportRequestsData } = useFastshiftSelector(
		(state) => state.topSupportRequests,
	);

	// Track event for migration tickets list displayed
	useEffect(() => {
		if (
			!identityAttrs ||
			!topSupportRequestsData ||
			(!isOrganizationRedesignEnabled && !selectedDomainOrg)
		)
			return;

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId: ActionSubjectIdKey.MIGRATION_TICKETS_TOP_SECTION_DETAILS,
			source: sourceKey,
			attributes: {
				...(!isOrganizationRedesignEnabled && selectedDomainOrg
					? { selectedOrgId: selectedDomainOrg.orgId }
					: {}),
				planTicketList: topSupportRequestsData.supportTickets.map(
					({ supportTicketId }) => supportTicketId,
				),
			},
		});
	}, [
		fireTrackEvent,
		sourceKey,
		selectedDomainOrg,
		topSupportRequestsData,
		identityAttrs,
		isOrganizationRedesignEnabled,
	]);
};
